import { FontWeights, makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  rowContainer: {
    height: 25,
  },
  statusType: {
    display: 'block',
    width: 110,
  },
  onrenderColumnStack: {
    height: 25,
  },
  footerTotal: {
    display: 'block',
    textAlign: 'right',
    fontWeight: FontWeights.bold,
  },
  checkboxContainer: {
    // flex: 0.2,
    justifyContent: 'end',
  },

  rowBaseStyle: { borderLeft: `5px solid transparent` },
  listTitleContainer: {
    height: 32,
    width: '100%',
    marginTop: 10,
    padding: 25,
  },
  dropdownTitle: {
    border: 0,
    outline: 0,
    borderBottom: `1px solid ${theme.semanticColors.inputBorder}`,
  },
  dropdown: {
    width: 140,
  },
}));
